import React, { useState } from "react";
import EditableField from "./EditableField";
import detailStyles from "../forms/DetailsModal.module.css";
import {
  getFieldValue,
  isFieldValueEmpty,
  renderCustomValue,
  editorTypeFor,
  editorOptionsFor,
} from "../../utils/customFieldUtils";

/**
 * The custom field rows of a lead or project detail panel.
 *
 * Fields that hold no value are collapsed behind a single toggle. With a
 * handful of fields that hardly matters; at fifteen, a properties list of
 * fifteen em-dashes buries the ones that are actually filled in, so the panel
 * shows what's set and keeps the rest one click away.
 */
export default function CustomFieldRows({
  fields = [],
  entity,
  disabled = false,
  formatMoney = null,
  onSave,
}) {
  const [showEmpty, setShowEmpty] = useState(false);

  if (fields.length === 0) return null;

  const filled = [];
  const empty = [];
  fields.forEach((field) => {
    const value = getFieldValue(entity, field);
    (isFieldValueEmpty(field, value) ? empty : filled).push({ field, value });
  });

  const visible = showEmpty ? [...filled, ...empty] : filled;

  const renderRow = ({ field, value }) => (
    <EditableField
      key={field.field_id}
      label={field.name}
      icon="tag"
      type={editorTypeFor(field)}
      options={editorOptionsFor(field)}
      value={value}
      disabled={disabled}
      placeholder={`Add ${field.name.toLowerCase()}`}
      formatDisplay={(val) => renderCustomValue(field, val, formatMoney)}
      onSave={(val) => onSave(field, val)}
    />
  );

  return (
    <>
      {visible.map(renderRow)}

      {empty.length > 0 && (
        <button
          type="button"
          className={detailStyles.addInlineButton}
          style={{ marginTop: '6px', alignSelf: 'flex-start' }}
          onClick={() => setShowEmpty((prev) => !prev)}
        >
          {showEmpty
            ? `Hide ${empty.length} empty field${empty.length === 1 ? '' : 's'}`
            : `Show ${empty.length} empty field${empty.length === 1 ? '' : 's'}`}
        </button>
      )}
    </>
  );
}
